import React from 'react'
import './modalEdit.css'
import x from './img/x.svg'
import trash from './img/trash.svg'

function ModalEditRoom(props) {
    return (
        <section
            style={{ display: `${props.show ? 'flex' : 'none'}` }}
            className='background-modalEdit-container'
        >
            <form onSubmit={props.function} style={{ ...props.style }} className='modalEdit-container-room '>
                <div>
                    <div className='modalEdit-container-top'>
                        <img onClick={props.close} src={x} alt='x' style={{cursor:"pointer"}} />
                        {
                            props.hidenDelete ?
                                null
                            :
                                <div style={props.hiddenTrash ? { display: 'none', ...props.trash } : {}} onClick={props.deletar} className='modalEdit-container_delete' >
                                    <img src={trash} alt='trash' onClick={props.deleteDH}/>
                                </div>
                        }
                        
                    </div>

                    <h1 className='modalEdit-container_title'>{props.title}</h1>
                    <p className='modalEdit-container_label'>{props.label}</p>
                    {
                        props.children
                    }
                </div>
                <button type='submit' disabled={props.disabled} style={{ ...props.styleButton, background: props.color }} className='modalEdit-container_button'>
                    {props.labelButton}
                    <img src={props.iconButton} alt='icon button' style={props.iconButton ? { display: 'flex' } : { display: 'none' }} />
                </button>
            </form>
        </section>
    );
}

export default ModalEditRoom